import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import moment from 'moment';

import { Checkbox, FormControl, FormControlLabel, Grid, MenuItem, Select, TextField } from '@mui/material';

import '../style.css';
import './form.css';
import './tabla.css';

import { FormActions } from './FormActions';
import { TablaInvoice } from './TablaInvoice';

import { Totales } from './Totales';
import { DatosIniciales } from './DatosIniciales';

import { useInvoices } from '../../../hooks/useInvoices';

import { getFinalTotals, getInfoTipoDoc, setNewItemsValues, setNewItemsName, calcDetraccion } from '../../../helpers/invoices';
import { Cobranza } from './Cobranza';
import { on } from '../../../utils/eventBus';

export const InvoiceForm = ({ initialState = {}, loadIniBudget, setOpen }) => {

    let { invoiceId } = useParams()
    /* console.log({ invoiceId }) */

    const { listaTiposDocumentos, currencyList, listaFormasPagosVentas, detail } = useSelector(state => state.general)
    const { no_mostrar_detraccion } = detail

    const { detailInvoice, initGetOneInvoice } = useInvoices()
    /* console.log({ detailInvoice }) */

    const [form, setForm] = useState(invoiceId ? detailInvoice : initialState)
    /* console.log({ form }) */

    const checkInitialData = useCallback(async (invoiceId) => {
        await initGetOneInvoice(invoiceId)
    }, [initGetOneInvoice])

    const handleChange = async ({ target }) => {

        if (target.name === 'id_forma_pago') {
            const newIdFormaPago = target.value

            const newEndDate = await calcExpirationDate({
                id_forma_pago: newIdFormaPago,
                fecha_emision: form.fecha_emision
            })

            setForm({
                ...form,
                [target.name]: newIdFormaPago,
                'fecha_vencimiento': newEndDate
            });

        } else {

            if (target.name === 'porcentaje_detraccion') {
                const newPercent = parseFloat(target.value || 0)

                const infoDetraccion = await calcDetraccion({
                    porcentaje_detraccion: newPercent,
                    totalFactura: form?.total_factura,
                    valor_tipo_cambio: form.valor_tipo_cambio,
                    id_moneda: form.id_moneda,
                    id_tipo_documento: form?.id_tipo_documento
                })

                // console.log({ infoDetraccion })

                setForm({
                    ...form,
                    aplica_detraccion: infoDetraccion.aplica_detraccion,
                    porcentaje_detraccion: newPercent,
                    total_detraccion: infoDetraccion.total_detraccion
                })

            } else {

                setForm({
                    ...form,
                    [target.name]: target.value
                });

            }

        }

    }

    const handleChangeTipoCambio = (value) => {
        setForm({
            ...form,
            'valor_tipo_cambio': value.floatValue,
        });
    }

    const handleChangeItemsName = async (e, itemId) => {
        const { value } = e.target

        const newItems = await setNewItemsName(value, itemId, form.items)

        setForm({
            ...form,
            items: newItems
        })

    }

    const handleChangeItemsTotals = async (values, target, itemId) => {

        const changedData = {
            itemId,
            target,
            floatValue: values.floatValue,
            items: form.items
        }

        const newItems = await setNewItemsValues(changedData)
        const { subtotal, monto_base, total_impuesto, total_factura } = await getFinalTotals(form, newItems)

        const infoDetraccion = await calcDetraccion({
            porcentaje_detraccion: form.porcentaje_detraccion,
            totalFactura: total_factura,
            valor_tipo_cambio: form.valor_tipo_cambio,
            id_moneda: form.id_moneda,
            id_tipo_documento: form?.id_tipo_documento
        })

        setForm({
            ...form,
            subtotal: subtotal,
            monto_base: monto_base,
            total_impuesto: total_impuesto,
            total_factura: total_factura,
            items: newItems,
            aplica_detraccion: infoDetraccion.aplica_detraccion,
            porcentaje_detraccion: infoDetraccion.porcentaje_detraccion,
            total_detraccion: infoDetraccion.total_detraccion
        })

    }

    const handleChangeTipoDoc = async ({ target }) => {
        const newTipoDocId = target.value
        const { impuesto_nombre, impuesto_porcentaje, impuesto_tipo_calculo } = await getInfoTipoDoc(listaTiposDocumentos, newTipoDocId)

        let newDataForm = {
            ...form,
            id_tipo_documento: newTipoDocId,
            impuesto_nombre: impuesto_nombre,
            impuesto_porcentaje: impuesto_porcentaje,
            impuesto_tipo_calculo: impuesto_tipo_calculo
        }

        const {
            subtotal,
            descuento,
            monto_base,
            total_impuesto,
            total_factura
        } = await getFinalTotals(newDataForm, newDataForm.items)

        let aplicaDetraccionAux = false
        let porcentajeDetraccionAux = 0
        let totalDetraccionAux = 0

        if (parseInt(newTipoDocId) === 1) {

            const infoDetraccion = await calcDetraccion({
                porcentaje_detraccion: form.porcentaje_detraccion,
                totalFactura: total_factura,
                valor_tipo_cambio: form.valor_tipo_cambio,
                id_moneda: form.id_moneda,
                id_tipo_documento: form?.id_tipo_documento
            })

            aplicaDetraccionAux = infoDetraccion.aplica_detraccion
            porcentajeDetraccionAux = infoDetraccion.porcentaje_detraccion
            totalDetraccionAux = infoDetraccion.total_detraccion

        }

        setForm({
            ...newDataForm,
            subtotal: subtotal,
            descuento: descuento,
            monto_base: monto_base,
            total_impuesto: total_impuesto,
            total_factura: total_factura,
            aplica_detraccion: aplicaDetraccionAux,
            porcentaje_detraccion: porcentajeDetraccionAux,
            total_detraccion: totalDetraccionAux
        })

    }

    const handleChangeCliente = (cliente) => {
        console.log({ cliente })

        setForm({
            ...form,
            'id_cliente': cliente.id_cliente
        });
    }

    const handleChangeDate = async (date, name) => {

        if (name === 'fecha_emision') {

            const newEndDate = await calcExpirationDate({
                id_forma_pago: form.id_forma_pago,
                fecha_emision: date
            })

            setForm({
                ...form,
                [name]: date,
                'fecha_vencimiento': newEndDate
            });

        } else {

            setForm({
                ...form,
                [name]: date,
            });

        }


    }

    const handleChangeCheck = async (e) => {
        const { checked } = e.target

        if (checked) {

            const infoDetraccion = await calcDetraccion({
                porcentaje_detraccion: form.porcentaje_detraccion,
                totalFactura: form.total_factura,
                valor_tipo_cambio: form.valor_tipo_cambio,
                id_moneda: form.id_moneda,
                id_tipo_documento: form?.id_tipo_documento
            })

            setForm({
                ...form,
                aplica_detraccion: checked,
                porcentaje_detraccion: infoDetraccion.porcentaje_detraccion,
                total_detraccion: infoDetraccion.total_detraccion
            })

        } else {

            setForm({
                ...form,
                aplica_detraccion: false,
                porcentaje_detraccion: 0,
                total_detraccion: 0
            })

        }


    }

    const calcExpirationDate = async (infoToCalc) => {

        const { id_forma_pago, fecha_emision } = infoToCalc
        const foundInfo = listaFormasPagosVentas.find(f => f.id === id_forma_pago)

        let numberDays = 0
        if (foundInfo) {
            numberDays = foundInfo.dias + 0
        }

        const newEndDate = moment(fecha_emision).add(numberDays, 'days').format('YYYY-MM-DD')
        return newEndDate

    }

    const handleChangeMoneda = ({ target }) => {
        const newIdMoneda = parseInt(target.value)
        const selectedMoney = currencyList?.find(it => it.id === newIdMoneda)
        setForm({
            ...form,
            [target.name]: newIdMoneda,
            separacion_decimales: selectedMoney?.separacion_decimales,
            separacion_miles: selectedMoney?.separacion_miles,
            simbolo: selectedMoney?.simbolo
        });
    }

    /* useEffect(() => {
        if (invoiceId) {
            checkInitialData(invoiceId)
        }

        return () => {
            if (!invoiceId) {
                loadIniBudget()
            }
        }

    }, [invoiceId, checkInitialData, loadIniBudget]) */

    useEffect(() => {
        if (invoiceId) {
            checkInitialData(invoiceId)
        }
    }, [checkInitialData, invoiceId])

    useEffect(() => {
        if (invoiceId) {
            setForm(detailInvoice)
        }
    }, [detailInvoice, invoiceId])

    useEffect(() => {

        const checkData = async () => {
            if (invoiceId) {
                await checkInitialData(invoiceId)
            }
        }

        const unsub = on("invoice_updated", checkData);
        return unsub;

    }, [checkInitialData, invoiceId]);


    return (
        <div className='p-compras-box'>

            {form.id > 0 &&
                <div className="row">
                    <div className="col-10">
                        <Link to={-1} className='d-inline-flex align-items-center mb-2 p-arrow-back'>
                            <i className="bi bi-arrow-left"></i>
                            <span className='ms-2'>Factura <label style={{ textTransform: 'uppercase' }}>#{form.numero}</label></span>
                        </Link>
                    </div>
                    <div className='col-2 d-inline-flex justify-content-end align-items-center'>
                        {form.estado === 'por emitir' &&
                            <span className='p-pptos-estado p-por-aprobar'>Por emitir</span>
                        }

                        {form.estado === 'pagada' &&
                            <span className='p-pptos-estado p-pagada'>Pagada</span>
                        }

                        {form.estado === 'emitida' &&
                            <span className='p-pptos-estado p-emitida'>Emitida</span>
                        }

                        {form.estado === 'anulada' &&
                            <div>
                                <span className='p-pptos-estado p-anulada'>Anulada</span>
                                <p style={{ color: 'gray', fontSize: '12px', textAlign: 'center' }}>
                                    {form.anulada_con_nc ? `Anulada con NC: ${form.anulada_numero_nc}` : 'Anulada de forma manual'}
                                </p>
                            </div>
                        }
                    </div>
                </div>
            }

            <div className='d-flex'>
                <Link className='p-link-origen' to={`/projects/${form.id_ppto}`} target={"_blank"}>
                    Proyecto: {form.referencia_origen}
                </Link>
            </div>

            <div className='row mt-2'>
                <div className='col'>
                    <FormActions
                        checkInitialData={checkInitialData}
                        setForm={setForm}
                        dataForm={form}
                        setOpenExtendedMode={setOpen}
                        loadIniBudget={loadIniBudget}
                    />
                </div>
            </div>

            <div className='row mt-2 p-box-datos'>
                <div className='col'>
                    <DatosIniciales
                        dataForm={form}
                        handleChange={handleChange}
                        handleChangeCliente={handleChangeCliente}
                        handleChangeDate={handleChangeDate}
                        handleChangeTipoDoc={handleChangeTipoDoc}
                        handleChangeTipoCambio={handleChangeTipoCambio}
                        handleChangeMoneda={handleChangeMoneda}
                    />
                </div>
            </div>

            <div className='row mt-3 p-box-datos'>
                <div className='col p-pptos-form-tabla'>

                    {(form.total_factura >= 700) &&
                        <div className='d-flex justify-content-end align-items-center'>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={handleChangeCheck}
                                        checked={form.aplica_detraccion}
                                        style={{ color: '#8E24AA' }}
                                    />
                                }
                                label="Aplica detracción"
                            />

                            <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }}>
                                <Select
                                    style={{ textAlign: 'center' }}
                                    name="porcentaje_detraccion"
                                    value={form.porcentaje_detraccion || 12}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={10}>10%</MenuItem>
                                    <MenuItem value={12}>12%</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    }

                    <div className="table-responsive">
                        <TablaInvoice
                            dataForm={form}
                            handleChangeItemsTotals={handleChangeItemsTotals}
                            handleChangeItemsName={handleChangeItemsName}
                        />
                    </div>
                </div>
            </div>

            <div className='row mt-4'>
                <div className='col'>

                    <Grid container>
                        <Grid item xs={12} md={6}>
                            <TextField
                                className='p-compras-box-observaciones'
                                id="standard-multiline-static"
                                label="Observaciones"
                                placeholder="Ingrese alguna observación para el gasto"
                                multiline
                                rows={4}
                                name="observaciones"
                                value={form.observaciones || ''}
                                onChange={handleChange}
                                disabled={form.reading_mode}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Cobranza
                                dataForm={form}
                                no_mostrar_detraccion={no_mostrar_detraccion}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Totales
                                dataForm={form}
                            />
                        </Grid>
                    </Grid>

                </div>
            </div>

        </div>
    )
}